import { ApolloQueryResult, gql } from '@apollo/client'

import { client } from '../client'
import { Transportation } from '../../types/transportation';


const FIND_TRANSPORTATION_QUERY = gql`
query FindTransportation($qtirLanguageId: Int!, $transportationTypeId: [Int], $findBy: String!, $value: String!) {
  findTransportation(qtirLanguageId: $qtirLanguageId, transportationTypeId: $transportationTypeId, findBy: $findBy, value: $value) {
    transportation {
      announcementId
      companyName
      driverIdNo
      driverIdType
      driverName
      phoneNumber
      requiresProductSelect
      registrationNumber
      scheduleFrom
      scheduleTo
      trailerRegistrationNumber
      transportationType
      transportationTypeId
    }
  }
}
`

interface FindTransportationVars {
  findBy: string,
  value: string,
  transportationTypeId?: number[],
  qtirLanguageId: number,
}

interface FindTransportationData {
  findTransportation: {
    transportation: Transportation
  }
}


export const findTransportation = async (args: FindTransportationVars): Promise<ApolloQueryResult<FindTransportationData>> => {
  return await client.query<FindTransportationData, FindTransportationVars>({ query: FIND_TRANSPORTATION_QUERY, variables: args })
}
